import {TopMenu} from "../../top-menu/TopMenu";
import {Footer} from "../../footer/Footer";
import TeamWork from '../../../assets/Hand_Holds_A_Tablet_original_1095353.jpg';
import './ContactUs.css';
import {useState} from "react";

export const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <div className="App">
            <TopMenu/>
            <div className="main-container fourth-column-container">
                <div className="two-columns-container">
                    <div className="company-image-wrapper contact-image-wrapper">
                        <img src={TeamWork}/>
                    </div>
                </div>
                <div className="history-text-container two-columns-container contact-us-column-wrapper">
                    <h1 className="page-title">Jim Truitt</h1>
                    <h2 className="page-subtitle">CEO</h2>
                    <p className="contact-text-wrapper">
                        <strong>Cel:</strong> (858) 344-2140 <br/>
                        <strong>Emails:</strong> <br/> <a href="mailto:jim@aircad.net">jim@aircad.net</a>
                        <br/>
                        <a href="mailto:jim@rockypointdetailing.com">jim@rockypointdetailing.com</a>
                    </p>
                    <h2 className="page-subtitle">Contact Us</h2>
                    <form onSubmit={handleSubmit} className="contact-form">
                        <label>
                            Name:
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </label>
                        <label>
                            Email:
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </label>
                        <label>
                            Message:
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            />
                        </label>
                        <div className="submit-button-wrapper">
                            <button className="submit" type="submit">Send</button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer/>
        </div>
    );
}